var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.012 17.106h1.629A3.455 3.455 0 0124 20.514 3.502 3.502 0 0120.563 24a3.432 3.432 0 01-3.44-3.173V19.03h-2.272v1.796A3.433 3.433 0 0111.41 24 3.497 3.497 0 018 20.618a3.44 3.44 0 013.334-3.512h1.629v-2.212h-1.63A3.44 3.44 0 018 11.382 3.479 3.479 0 0111.412 8a3.433 3.433 0 013.439 3.174v1.796h2.273v-1.796A3.434 3.434 0 0120.563 8 3.522 3.522 0 0124 11.487a3.455 3.455 0 01-3.36 3.407h-1.628v2.212zm-7.678-4.136h1.629v-1.692a1.5 1.5 0 00-1.524-1.352 1.541 1.541 0 00-1.529 1.553q0 .043.003.085a1.576 1.576 0 001.42 1.406zm1.629 7.752v-1.69h-1.63a1.624 1.624 0 00-1.42 1.378 1.589 1.589 0 001.483 1.688l.043.003a1.502 1.502 0 001.524-1.38zm1.888-3.616h2.273v-2.212H14.85zm4.16-5.828v1.692h1.63a1.552 1.552 0 001.42-1.535 1.53 1.53 0 00-3.05-.156zm1.63 7.754h-1.63v1.69a1.521 1.521 0 001.527 1.38 1.549 1.549 0 001.524-1.535 1.569 1.569 0 00-1.421-1.535z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--attraction-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'AttractionCircleIcon';
export default Icon;